import React from "react";
import { Trash } from "react-bootstrap-icons";
import { Pencil } from "react-bootstrap-icons";
import { Badge } from "react-bootstrap";
import { Eye } from "react-bootstrap-icons";
import { ConvertArrayTOString } from "../../common/utils/arrayToString";
import Loader from "../../common/utils/loader";
import Pagination from "../../common/pagination";

import Offcanvas from "react-bootstrap/Offcanvas";
import { CheckAccess } from "../../common/utils/roleAccess";
import moment from "moment";
import useTagsHook from "./tagsHook";
import TagsCreate from "./TagsCreate";
function TagsManage() {
  const pageTitle = "Manage Tags";

  const {
    onSubmit,
    onUpdate,
    navigate,
    register,
    handleDelete,
    handleSubmit,
    errors,
    tagsList,
    setTagsList,
    sectionItem,
    setSectionItem,
    setValue,
    isOpenCanvas,
    setIsOpenCanvas,
    parents,
    setParents,
    fetchTagsList,
    sectionOption,
    ontagsListUpdate,
    currentPage,
    setCurrentPage,
    totalPages,
    show,
    setShow,
    handleClose,
    getValues,
    generateSlug,
  } = useTagsHook();

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <>
      <div className="content">
        <div className="">
          <div className="card col-lg-12">
            <div className="card-header">
              <h3 className="text-bold">{pageTitle}</h3>

              <input
                type="search"
                placeholder="Enter name or slug"
                className="form-control story-search-input"
                onChange={(e) => {
                  fetchTagsList(e?.target?.value)
                }}
              />

              <div className="timeline-footer text-right">
                {CheckAccess("tags", "create") && (
                  <button
                    type="button"
                    className="btn btn-primary btn-round btn-sm"
                    role="button"
                    onClick={() => {
                      setSectionItem('');
                      setShow(true);
                      setValue("status", "Active");
                    }}
                  >
                    Add Tags
                  </button>
                )}
                &nbsp;
              </div>
            </div>
            <div className="">
              <table className="table table-bordered text-center table-responsive">
                <thead className="">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Slug</th>
                    <th scope="col">Stories</th>
                    <th scope="col">Created On</th>
                    <th scope="col">Created By</th>
                    <th scope="col">Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {!tagsList?.length > 0 ? (
                    <Loader />
                  ) : (
                    tagsList?.map((item, key) => {
                      return (
                        <tr key={key}>
                          <th scope="row" className="p-4">
                            {key + 1}
                          </th>
                          <td className="p-4">{item.name} </td>
                          <td className="p-4">{item.slug} </td>
                          <td className="p-4">{item?.stories || `--`}</td>
                          <td className="p-4">
                            {moment(item.created_on).format(
                              "MMMM, DD YYYY | hh:mm:ss a"
                            )}{" "}
                          </td>
                          <td className="p-4">{item?.created_by} </td>

                          <td>
                            <div>
                              <Badge
                                bg={
                                  item.status === "Active"
                                    ? "success"
                                    : "danger"
                                }
                                text="white"
                              >
                                {item.status}
                              </Badge>
                            </div>
                          </td>
                          <td>
                            {/* {CheckAccess("tags", "view") && (
                              <button
                                type="button"
                                className="btn btn"
                                onClick={() => {
                                  navigate(`/tags/${item?._id}`);
                                }}
                              >
                                <Eye
                                  color="royalblue"
                                  size={16}
                                  data-toggle="tooltip"
                                  title="View Description"
                                />
                              </button>
                            )} */}

                            {CheckAccess("tags", "update") && (
                              <button
                                type="button"
                                onClick={() => {
                                  setSectionItem(item);
                                  setShow(true);
                                }}
                                className="btn btn"
                              >
                                <Pencil
                                  color="royalblue"
                                  size={16}
                                  data-toggle="tooltip"
                                  title="Edit"
                                />
                              </button>
                            )}
                            {CheckAccess("tags", "delete") && (
                              <button
                                type="button"
                                size={16}
                                className="btn btn"
                                onClick={() => handleDelete(item._id)}
                              >
                                <Trash
                                  color="royalblue"
                                  size={16}
                                  data-toggle="tooltip"
                                  title="Delete"
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
              {totalPages ? (
                <div className={`container`}>
                  <div className={`row`}>
                    <div
                      className={`col-sm-12 d-flex justify-content-center px-0`}
                    >
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                  <br />
                </div>
              ) : (
                ""
              )}

              {/* offcanvas start from here manage part start */}
              <Offcanvas
                // className="story-canvas"
                show={show}
                onHide={handleClose}
                placement="end"
              >
                <TagsCreate
                  onSubmit={onSubmit}
                  onUpdate={onUpdate}
                  register={register}
                  setValue={setValue}
                  sectionItem={sectionItem}
                  handleSubmit={handleSubmit}
                  tagsList={tagsList}
                  errors={errors}
                  show={show}
                  setShow={setShow}
                  generateSlug={generateSlug}
                />
              </Offcanvas>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TagsManage;
